import React from 'react';

import ErrorReporter from 'app/components/ErrorReporter';
import FormElement from 'components/FormElement';
import GetRefundReasonsContainer from 'coaching/containers/GetRefundReasonsContainer';
import Select from 'components/Select';

export type Props = {
  changeState: (reason: string) => void;
};

export const RefundReasonsSelect = ({ changeState }: Props) => {
  const [selectedReason, setSelectedReason] = React.useState('');

  return (
    <GetRefundReasonsContainer>
      {({ refundReasons, error }) => {
        if (error || !refundReasons) {
          return <ErrorReporter error={error ?? 'Could not load refund reasons'} />;
        }
        return (
          <FormElement
            data-test="refund-reason-dropdown"
            label="Process refund"
            element={Select}
            elementProps={{
              options: refundReasons.map(reason => ({
                label: reason.uiLabel,
                value: reason.slug,
              })),
              value: selectedReason,
              name: 'reason',
              placeholder: 'Select a reason',
            }}
            onValidChange={value => {
              setSelectedReason(value);
              changeState(value);
            }}
          />
        );
      }}
    </GetRefundReasonsContainer>
  );
};
